import React from "react";
import { Button, Tooltip } from "@mui/material";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { exportRowsToExcel } from "../../utils/formatters/exportToExcel";

const ExportExcelButton = ({
  rows,
  columns,
  filename,
  label = "Export Excel",
  disabled = false,
  size = "small",
  variant = "outlined",
  tooltip = "Download table as Excel-compatible CSV",
}) => {
  const empty = !Array.isArray(rows) || rows.length === 0;
  const isDisabled = disabled || empty;

  const handleClick = () => {
    exportRowsToExcel({ rows, columns, filename });
  };

  return (
    <Tooltip title={empty ? "No rows to export" : tooltip}>
      <span>
        <Button
          size={size}
          variant={variant}
          startIcon={<FileDownloadOutlinedIcon />}
          onClick={handleClick}
          disabled={isDisabled}
          sx={{ textTransform: "none" }}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};

export default ExportExcelButton;
